import { DataSubject } from '@main/datamap-types';
import { SanitizeHtml } from '@main/pc-core-components';
import { privacyCenterCustomizableMessages } from '@main/pc-types';
import { Login } from '@main/privacy-center/src/containers/Login';
import React from 'react';
import { useIntl } from 'react-intl';

import { usePartition } from '../../hooks/usePartition';
import { takeControlMessages } from './messages';
import {
  DataSubjectValueWrapper,
  DataSubjectWrapper,
  DescriptionWrapper,
  TextWrapper,
  TitleWrapper,
} from './wrappers';

export interface TakeControlTitleProps {
  /** whether the user is logged in */
  isLoggedIn: boolean;
  /** dataSubject navigating the form */
  activeDataSubject: DataSubject;
}

export const TakeControlTitle: React.FC<
  React.PropsWithChildren<TakeControlTitleProps>
> = ({ isLoggedIn, activeDataSubject }) => {
  const { formatMessage } = useIntl();
  const [{ selectedPartitionOption, partitionOptions, showPartition }] =
    usePartition();

  const submitDisabled = !!activeDataSubject.disabledInstructions;
  const renderPartition =
    showPartition && selectedPartitionOption && partitionOptions?.length > 0;
  return (
    <TextWrapper>
      {submitDisabled && (
        <TitleWrapper>{formatMessage(takeControlMessages.title)}</TitleWrapper>
      )}
      <DescriptionWrapper>
        <SanitizeHtml
          html={formatMessage(
            activeDataSubject.disabledInstructions ??
              privacyCenterCustomizableMessages.takeControlDescription,
          )}
        />
      </DescriptionWrapper>
      {!submitDisabled && (
        <>
          <DataSubjectWrapper>
            {isLoggedIn
              ? formatMessage(takeControlMessages.dataSubjectLoggedIn, {
                  dataSubject: (
                    <DataSubjectValueWrapper>
                      {formatMessage(activeDataSubject.title).toLowerCase()}
                    </DataSubjectValueWrapper>
                  ),
                })
              : formatMessage(takeControlMessages.dataSubjectNotLoggedIn, {
                  verifyIdentityLogin: <Login />,
                })}
          </DataSubjectWrapper>
          {renderPartition && (
            <DataSubjectWrapper>
              {formatMessage(takeControlMessages.partitionLoggedIn, {
                partition: selectedPartitionOption.label,
              })}
            </DataSubjectWrapper>
          )}
        </>
      )}
    </TextWrapper>
  );
};

export default TakeControlTitle;
